import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/api/api.service';
import {
  ICardUI,
  INewCompletedAccountCardsState,
} from 'src/app/api/interfaces/card.interface';
import { ICharacterReplenishment } from 'src/app/api/interfaces/character.interface';
import { MapModalService } from 'src/app/modules/global-map/services/map-modal.service';
import { PhaserService } from 'src/app/modules/main-game/phaser/phaser.service';
import {
  ICompletedCharacterSlots,
  selectCharacterState,
} from 'src/app/store/characterState/characterState.reducer';
import {
  IMainState,
  selectMainState,
} from 'src/app/store/mainState/mainState.reducer';
export interface IRestoreBoostingCharacterCards {
  apiCard: ICardUI;
  userCards: INewCompletedAccountCardsState[];
  count: number;
  restoreValue: number;
}
[];
@Component({
  selector: 'app-energy-restoring',
  templateUrl: './energy-restoring.component.html',
  styleUrls: ['./energy-restoring.component.scss'],
})
export class EnergyRestoringComponent implements OnInit, OnDestroy {
  public characterSlot: ICompletedCharacterSlots | undefined;
  public cards: IRestoreBoostingCharacterCards[] = [];
  private subsriptions: Subscription[] = [];
  constructor(
    private state: Store,
    private modalService: MapModalService,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.subsriptions.push(
      combineLatest([
        this.state.select(selectCharacterState),
        this.state.select(selectMainState),
        this.modalService.characterSlotId,
      ]).subscribe((res) => {
        const character = res[0].completedCharacterSlots.find(
          (characterSlot) => characterSlot.character?.id === res[2]
        );
        character?.character?.energy;
        if (character?.character) {
          this.characterSlot = character;
          const characterEnergy = {
            quantity: character.character.energy.quantity,
            capacity: character.character?.energy.capacity,
          };
          if (characterEnergy.capacity && characterEnergy.capacity) {
            this.cards = res[1].cards.api.cards
              .filter((card) =>
                this.modalService.currentModalType === 'energyRestoring'
                  ? card.type === 'ENERGETIC'
                  : card.type === 'EXPERIENCE'
              )
              .map((apiCard) => {
                const userCards = res[1].cards.completedCards
                  .filter((userCard) => userCard.card.cardId === apiCard.id)
                  .filter((card) => card.card.status === 'ACTIVE');
                const calculatedValue = this.modalService.calculateCardCount(
                  apiCard.meta.value ? apiCard.meta.value : 0,
                  userCards.length,
                  characterEnergy.capacity - characterEnergy.quantity
                );
                return {
                  apiCard: apiCard,
                  userCards: userCards,
                  count: calculatedValue.count,
                  restoreValue: calculatedValue.restoreValue,
                };
              });
          }
        }
      })
    );
  }
  public useReplenishment(cardInfo: { cardId: number; count: number }): void {
    if (this.characterSlot?.character?.id) {
      const body: ICharacterReplenishment = {
        characterId: this.characterSlot.character.id,
        cardId: cardInfo.cardId,
        count: cardInfo.count,
      };
      this.api
        .characterReplenishmentActions('energyReplenishment', body)
        .subscribe((res) => {});
    }
  }
  ngOnDestroy(): void {
    this.subsriptions.forEach((subsc) => subsc.unsubscribe());
  }
}
